var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#FDD800;}\n"),React.createElement("path",{"className":"st0","d":"M63.8,1C28.7,1,0.2,29.5,0.2,64.6c0,34.4,27.3,62.4,61.5,63.5V82H46.2V64h15.5V50.8c0-15.4,9.4-23.7,23.1-23.7\n\tc6.6,0,12.2,0.5,13.9,0.7v16.1h-9.5c-7.5,0-8.9,3.6-8.9,8.7V64h17.8l-2.3,18H80.3v44c27.1-7.3,47.1-32,47.1-61.4\n\tC127.4,29.5,99,1,63.8,1z","key":1})]);
}

Facebook.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 128 128","style":{"enableBackground":"new 0 0 128 128"},"xmlSpace":"preserve"};

module.exports = Facebook;

Facebook.default = Facebook;
